import { render, staticRenderFns } from "./PredbeznaCena.vue?vue&type=template&id=cac83f2e&"
import script from "./PredbeznaCena.vue?vue&type=script&lang=ts&"
export * from "./PredbeznaCena.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports